export const openBasicJobCreditsPayment = (id: string) => {
  const link = import.meta.env.REACT_APP_PAYMENT_JOB_BASIC_CREDIT_LINK || ''
  const linkParams = `id=${id}`

  window.open(`${link}?${linkParams}`, '_blank')
}
